import React, { Component, Fragment } from 'react'
import ReactSVG from 'react-svg';
import _map from 'lodash/map';
// import { Blobber } from 'src/components/blobber/Blobber';
import "./HowSteps.scss";

export class HowSteps extends Component {

  // componentDidMount() {
  //   const positionX = 56 * (parseInt(this.props.step) - 1);
  //   const blob = new Blobber({ alpha: 1, color: 0xffffff, x: positionX + 18, y: 18, radius: 12 });
  //     blob.createCanvas({ transparent: true, width: 209, height: 40 });
  //     blob.startWobbling({
  //       wobble: {
  //           position: () => ({ min: -3, max: 3 }),
  //           length: (length) => ({ min: length * .8, max: length * 1.2 }),
  //           angle: (angle) => ({ min: -Math.PI / 20, max: Math.PI / 20 }),
  //       },
  //       timeRange: { min: 700, max: 2500 },
  //     });
  //     blob.attachToElement(this.refs.blobs);
  // }

  createCircle({ hasArrow = true, isActive = false, isComplete = false, key }) {
    return (
      <Fragment key={key}>
        <div className={`HowSteps-outline ${isActive ? 'HowSteps-outline--active' : ''}  ${isComplete ? 'HowSteps-outline--complete' : ''}`} >
          { isComplete ? <ReactSVG className="HowSteps-tick" src="./assets/how/step-tick.svg" /> : null }
        </div>
        { hasArrow ? <ReactSVG className="HowSteps-arrow" src="./assets/how/step-arrow.svg" /> : null }
      </Fragment>
    );
  }

  render() {
    const { step, title } = this.props;
    return (
      <div className="HowSteps">
        <div className="HowSteps-image">
          { _map([1,2,3,4], (num, i, list) => this.createCircle({ key: i, hasArrow: i < list.length - 1, isActive: num === step, isComplete: step > num })) }
        </div>
        <h3>
          <div className="HowSteps-number">Step {step}</div>
          <div className="HowSteps-title">{title}</div>
        </h3>
      </div>
    )
  }
}
